module.exports = __webpack_public_path__ + "img/video-corporativo-y-eventos_info.e99eff65.jpg";